import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@express-labs/raven-tools';
import { Icon } from '@express-labs/raven-ui';
import s from './CircleProgressBar.module.scss';

function CircleProgressBar(props) {
  const {
    className, rewardList, goal, completed, useRewardIcon, ...restOfProps
  } = props;
  const r = 22;
  const c = Math.PI * (r * 2);

  function getoffset(target, finished) {
    const pct = (finished * 100) / target / 100;
    const offset = c * (1 - pct);
    return offset;
  }

  const iconClass = useRewardIcon ? s.newIcon : s.oldIcon;

  return (
    <div className={cn(s.container, className, iconClass)} data-list={rewardList} {...restOfProps}>
      <svg
        className={s.svg}
        width="50"
        height="50"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle r={r} cx="25" cy="25" fill="transparent" strokeDasharray={c} strokeDashoffset="0" />
        <circle
          className={s.bar}
          r={r}
          cx="25"
          cy="25"
          fill="transparent"
          strokeDasharray={c}
          strokeDashoffset="0"
          style={{ strokeDashoffset: `${getoffset(goal, completed)}` }}
        />
      </svg>
      {useRewardIcon && <Icon icon="rewardsEmptyWhite" />}
    </div>
  );
}

CircleProgressBar.propTypes = {
  className: PropTypes.string,
  rewardList: PropTypes.string,
  goal: PropTypes.number,
  completed: PropTypes.number,
  useRewardIcon: PropTypes.bool,
};

CircleProgressBar.defaultProps = {
  className: null,
  rewardList: 'A',
  goal: 100,
  completed: 0,
  useRewardIcon: false,
};

export default CircleProgressBar;
